export default __webpack_public_path__ + "59c482c26955be73e2336788c5360341.svg";